import { isAForm } from "../libs/helpers/util";
import { ROUTE_NAMES } from "./route-names";

const PARTNER = "Partner";
const PARTNERTYPE = "Partnertype";

export const PARTNER_PARTNERTYPE = {
    [PARTNER]: "Pacífico",
    [PARTNERTYPE]: "Pacífico",
};

export const PAGENAMES = {
    [ROUTE_NAMES.HOME_INSURANCE.LANDING]: `Seguro Hogar ${isAForm ? 'Leads' : ''} - Inicio`,
    [ROUTE_NAMES.HOME_INSURANCE.STEP1]: "Seguro Hogar - Datos del cliente",
    [ROUTE_NAMES.HOME_INSURANCE.STEP2]: "Seguro Hogar - Datos iniciales del inmueble",
    [ROUTE_NAMES.HOME_INSURANCE.STEP3]: "Seguro Hogar - Cotización",
    [ROUTE_NAMES.HOME_INSURANCE.STEP4]: "Seguro Hogar - Datos del inmueble",
    [ROUTE_NAMES.HOME_INSURANCE.STEP5]: "Seguro Hogar - Pago",
    [ROUTE_NAMES.HOME_INSURANCE.CONFIRM1]: "Seguro Hogar - Confirmación",
    [ROUTE_NAMES.HOME_INSURANCE.THANKS]: `Seguro Hogar ${isAForm ? 'Leads' : ''} - Gracias`,
};

export const getPageNames = url => {
    const urls = url.split("/");
    const systemUrl = `/${urls[urls.length - 1]}`;
    return PAGENAMES[systemUrl];
};

export const PARTNER_NAME = {
    callcenter: "CALLCENTER",
    default: "PACÍFICO",
};

export const PARTNER_TYPE = {
    client: "Clientes",
    company: "Empresas",
    default: "Pacífico",
    bcp: "BCP",
    mibanco: "MiBanco",
    crosssoat: "CROSSSOAT",
};

export const VIRTUAL_EVENT = "virtualEvent";

export const ADD_TO_CART = "addToCart";

export const PRODUCT_CHECKOUT = "productCheckout";

export const ORDER_PURCHASE = "orderPurchase";

export const ECOMMERCE_NAME = "Seguro Hogar";

export const AFFILIATION = "Ecommerce Hogar";

export const PACIFICTO_CATEGORY = "Pacifico - Seguro Hogar";

export const NOT_AVAILABLE = "(not available)";

export const MODAL_TYPES = {
    ERROR: "Error",
    INFO: "Informativo",
};

export const MODAL_NAMES = {
    GENERIC_MODAL: "Error general",
    NO_INTERNET: "No Internet",
    SERVICE_ERROR: "Error de Servicio",
    TIMEOUT_ERROR: "Sobrepaso de tiempo de espera",
    LANDING_VIDEO: "Pacifico hogar video",
    COVERAGE_TYPES: "Tipos de coberturas",
};

export const CLICK_ACTIONS = {
    SELECT_LINK: "Seleccionar Link",
    SELECT_VIDEO: "Seleccionar video",
    SELECT: "Seleccionar",
    OPEN_MODAL: "Visualizar modal",
    CLOSE_MODAL: "Cerrar Modal",
    SELECT_BUTTON: "Seleccionar Botón",
    CALCULATE_QUOTATION: "Calcular cuota mensual",
    COVERAGE: "Conocer más cobertura",
    ADD_COVERAGE: "Agregar cobertura",
};

export const CLICK_DESCRIPTION = {
    RETRY: "Reintentar",
    GO_BACK: "Volver",
    BENEFITS: "​Conoce más nuestros beneficios",
    TUTORIAL_VIDEO: "Video tutorial Hogar FlexDigital",
    TERMS_CONDITIONS_HOGARFLEX:
        "Conoce el detalle de todas nuestras coberturas y exclusiones aquí",
    BTN_GO_BACK: "Volver al inicio",
    BTN_CALCULATE: "Calcula la cuota mensual",
    BTN_QUOTATION: "Cotización y compra aquí",
    PRIME_COVERAGE:
        "Incendio, explosión, daños accidentales por agua y daños por vandalismo",
    COVERAGES_BENEFITS_EXCLUSIONS: "Coberturas, beneficios y exclusiones",
};
